import React from 'react';
import './App.css';
import BirthdayCard from './components/BirthdayCard';
import Bubbles from './components/Bubbles';

function App() {
  return (
    <div className="app-container">
      <div className="App">
        <Bubbles />
        <div className="card-wrapper">
          <BirthdayCard name="Mekynzie" />
        </div>
      </div>
    </div>
  );
}

export default App;
